export default __webpack_public_path__ + "static/media/Inf.ed2e286c.svg";